(function() {
  'use strict';

  var dataEl = document.querySelector('[data-reservation-data]');
  if (!dataEl) return;

  var data = JSON.parse(dataEl.textContent);
  var journees = data.journees;
  var moneyFormat = data.moneyFormat;

  // State
  var state = {
    step: 1,
    selectedJournee: null,
    selectedVariantId: null,
    selectedVariantTitle: null,
    selectedAtelier: null,
    qty: 2,
    calendarYear: null,
    calendarMonth: null,
    selectedDate: null
  };

  // DOM refs
  var stepsContainer = document.querySelector('.atelier-resa__steps');
  var ateliersContainer = document.querySelector('[data-ateliers-container]');
  var progressSteps = document.querySelectorAll('[data-progress-step]');

  // Calendar DOM refs
  var calendarGrid = document.querySelector('[data-calendar-grid]');
  var calendarMonthLabel = document.querySelector('[data-calendar-month]');
  var calendarSlotsContainer = document.querySelector('[data-calendar-slots]');
  var calendarPrevBtn = document.querySelector('[data-calendar-prev]');
  var calendarNextBtn = document.querySelector('[data-calendar-next]');

  // Calendar data
  var dateMap = {};
  var MONTH_NAMES = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  var DAY_NAMES = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  var DAY_HEADERS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  // Pre-selected atelier from URL parameter
  var urlParams = new URLSearchParams(window.location.search);
  var preselectedAtelierId = urlParams.get('atelier') ? parseInt(urlParams.get('atelier')) : null;
  var preselectedMinDelayHours = 24; // par défaut, calculé dans initCalendar()

  // Recap elements
  var recapCreneau = document.querySelector('[data-recap-creneau]');
  var recapAtelier = document.querySelector('[data-recap-atelier]');
  var recapDuree = document.querySelector('[data-recap-duree]');
  var recapPrix = document.querySelector('[data-recap-prix]');
  var totalPrice = document.querySelector('[data-total-price]');
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyHint = document.querySelector('[data-qty-hint]');
  var submitBtn = document.querySelector('[data-submit-reservation]');

  // ─── Money formatting ───
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    if (moneyFormat) {
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{ amount }}', amount)
        .replace('{{amount_with_comma_separator}}', amount)
        .replace('{{ amount_with_comma_separator }}', amount);
    }
    return amount + ' €';
  }

  // ─── Navigation ───
  function goToStep(stepNum) {
    state.step = stepNum;

    var steps = stepsContainer.querySelectorAll('[data-step]');
    steps.forEach(function(el) {
      var s = parseInt(el.getAttribute('data-step'));
      if (s === stepNum) {
        el.classList.add('atelier-resa__step--active');
      } else {
        el.classList.remove('atelier-resa__step--active');
      }
    });

    progressSteps.forEach(function(el) {
      var s = parseInt(el.getAttribute('data-progress-step'));
      el.classList.toggle('atelier-resa__progress-step--active', s <= stepNum);
      el.classList.toggle('atelier-resa__progress-step--current', s === stepNum);
    });

    var section = document.querySelector('.atelier-resa');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ─── Step 1: Calendar ───

  function parseDateFromVariant(title) {
    var match = title.match(/^(\d{2})\/(\d{2})\/(\d{4})\s*:\s*(.+)$/);
    if (!match) return null;
    var day = match[1], month = match[2], year = match[3], timeLabel = match[4].trim();
    return {
      dateKey: year + '-' + month + '-' + day,
      timeLabel: timeLabel
    };
  }

  function buildDateMap(journeesData) {
    dateMap = {};
    journeesData.forEach(function(journee) {
      // If an atelier is preselected, only include journées that offer it
      if (preselectedAtelierId) {
        var hasAtelier = journee.ateliers && journee.ateliers.some(function(a) {
          return a.productId === preselectedAtelierId;
        });
        if (!hasAtelier) return;
      }

      journee.creneaux.forEach(function(creneau) {
        var parsed = parseDateFromVariant(creneau.title);
        if (!parsed) return;
        if (!dateMap[parsed.dateKey]) {
          dateMap[parsed.dateKey] = [];
        }
        dateMap[parsed.dateKey].push({
          journee: journee,
          variantId: creneau.variantId,
          variantTitle: creneau.title,
          timeLabel: parsed.timeLabel,
          available: creneau.available
        });
      });
    });
  }

  function formatDateFrench(dateKey) {
    var parts = dateKey.split('-');
    var y = parseInt(parts[0]), m = parseInt(parts[1]) - 1, d = parseInt(parts[2]);
    var date = new Date(y, m, d);
    var weekday = DAY_NAMES[date.getDay()];
    var monthName = MONTH_NAMES[m].toLowerCase();
    return weekday + ' ' + d + ' ' + monthName + ' ' + y;
  }

  function getTodayKey() {
    var now = new Date();
    var mm = String(now.getMonth() + 1).padStart(2, '0');
    var dd = String(now.getDate()).padStart(2, '0');
    return now.getFullYear() + '-' + mm + '-' + dd;
  }

  // Renvoie true si dateKey (YYYY-MM-DD) respecte un délai minimum
  // exprimé en heures, mais converti en JOURS calendaires :
  //   24h → J+1 autorisé
  //   48h → J+2 autorisé
  // (on raisonne en jours pour éviter qu'un atelier 24h soit refusé si
  // l'utilisateur consulte le site en fin de journée)
  function meetsMinDelay(dateKey, minDelayHours) {
    if (!minDelayHours || minDelayHours <= 0) return true;
    if (!dateKey) return true;
    var minDays = Math.ceil(minDelayHours / 24);
    var parts = dateKey.split('-');
    var target = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var diffDays = Math.round((target.getTime() - today.getTime()) / 86400000);
    return diffDays >= minDays;
  }

  function renderCalendar(year, month) {
    if (!calendarGrid || !calendarMonthLabel) return;

    state.calendarYear = year;
    state.calendarMonth = month;

    calendarMonthLabel.textContent = MONTH_NAMES[month] + ' ' + year;

    var firstDay = new Date(year, month, 1);
    var offset = (firstDay.getDay() + 6) % 7; // Monday = 0
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var daysInPrevMonth = new Date(year, month, 0).getDate();

    var todayKey = getTodayKey();

    var html = '<div class="atelier-resa__calendar-weekdays">';
    DAY_HEADERS.forEach(function(d) {
      html += '<span class="atelier-resa__calendar-weekday">' + d + '</span>';
    });
    html += '</div>';

    html += '<div class="atelier-resa__calendar-days">';

    // Previous month trailing days
    for (var p = offset - 1; p >= 0; p--) {
      html += '<span class="atelier-resa__calendar-day atelier-resa__calendar-day--other">' + (daysInPrevMonth - p) + '</span>';
    }

    // Current month days
    for (var d = 1; d <= daysInMonth; d++) {
      var mm = String(month + 1).padStart(2, '0');
      var dd = String(d).padStart(2, '0');
      var dateKey = year + '-' + mm + '-' + dd;
      var classes = 'atelier-resa__calendar-day';
      var isButton = false;

      // Date "passée" = strictement avant aujourd'hui OU délai minimum non atteint
      // (uniquement quand un atelier est pré-sélectionné via ?atelier=)
      var isPast = dateKey < todayKey;
      if (!isPast && preselectedAtelierId) {
        isPast = !meetsMinDelay(dateKey, preselectedMinDelayHours);
      }
      var isToday = dateKey === todayKey;
      var slots = dateMap[dateKey];
      var hasAvailable = false;
      var allComplet = false;

      if (slots) {
        hasAvailable = slots.some(function(s) { return s.available; });
        allComplet = !hasAvailable;
      }

      if (isPast) {
        classes += ' atelier-resa__calendar-day--past';
      } else if (hasAvailable) {
        classes += ' atelier-resa__calendar-day--has-slots';
        isButton = true;
      } else if (allComplet) {
        classes += ' atelier-resa__calendar-day--complet';
        isButton = true;
      }

      if (isToday) {
        classes += ' atelier-resa__calendar-day--today';
      }

      if (state.selectedDate === dateKey) {
        classes += ' atelier-resa__calendar-day--selected';
      }

      if (isButton) {
        html += '<button type="button" class="' + classes + '" data-date="' + dateKey + '">' + d + '</button>';
      } else {
        html += '<span class="' + classes + '">' + d + '</span>';
      }
    }

    // Next month leading days
    var totalCells = offset + daysInMonth;
    var remaining = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
    for (var n = 1; n <= remaining; n++) {
      html += '<span class="atelier-resa__calendar-day atelier-resa__calendar-day--other">' + n + '</span>';
    }

    html += '</div>';

    calendarGrid.innerHTML = html;

    // Attach click handlers to day buttons
    calendarGrid.querySelectorAll('[data-date]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dateKey = btn.getAttribute('data-date');
        state.selectedDate = dateKey;
        renderCalendar(state.calendarYear, state.calendarMonth);
        renderTimeSlots(dateKey);
        // Scroll vers les créneaux horaires
        setTimeout(function() {
          if (calendarSlotsContainer && calendarSlotsContainer.style.display !== 'none') {
            calendarSlotsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      });
    });

    // Update nav button states
    updateCalendarNav();
  }

  function updateCalendarNav() {
    // Disable prev if before current month
    var now = new Date();
    if (calendarPrevBtn) {
      calendarPrevBtn.disabled = (state.calendarYear < now.getFullYear()) ||
        (state.calendarYear === now.getFullYear() && state.calendarMonth <= now.getMonth());
    }
  }

  function renderTimeSlots(dateKey) {
    if (!calendarSlotsContainer) return;
    var slots = dateMap[dateKey];

    if (!slots || slots.length === 0) {
      calendarSlotsContainer.style.display = 'none';
      return;
    }

    calendarSlotsContainer.style.display = '';

    var dateLabel = formatDateFrench(dateKey);
    var html = '<h4 class="atelier-resa__calendar-slots-title">' + escapeHtml(dateLabel) + '</h4>';
    html += '<p class="atelier-resa__step-desc">Veuillez sélectionner un créneau horaire pour cette date.</p>';

    // Group slots by journee
    var groups = {};
    slots.forEach(function(slot) {
      var key = slot.journee.productId;
      if (!groups[key]) {
        groups[key] = { journee: slot.journee, slots: [] };
      }
      groups[key].slots.push(slot);
    });

    var groupKeys = Object.keys(groups);
    groupKeys.forEach(function(key) {
      var group = groups[key];

      /* Guide masqué pour le moment
      if (group.journee.guide) {
        html += '<div class="atelier-resa__calendar-slots-guide">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg> ' +
          escapeHtml(group.journee.guide) +
          '</div>';
      }
      */

      html += '<div class="atelier-resa__calendar-slots-list">';
      group.slots.forEach(function(slot) {
        var btnClass = 'atelier-resa__horaire';
        var disabled = '';
        if (!slot.available) {
          btnClass += ' atelier-resa__horaire--complet';
          disabled = ' disabled';
        }
        html += '<button type="button" class="' + btnClass + '" data-slot-journee-id="' + slot.journee.productId + '" data-slot-variant-id="' + slot.variantId + '"' + disabled + '>' +
          '<span class="atelier-resa__horaire-time">' + escapeHtml(slot.timeLabel) + '</span>' +
          (!slot.available ? '<span class="atelier-resa__horaire-badge">Complet</span>' : '') +
          '</button>';
      });
      html += '</div>';
    });

    calendarSlotsContainer.innerHTML = html;

    // Attach click handlers to slot buttons
    calendarSlotsContainer.querySelectorAll('.atelier-resa__horaire:not(.atelier-resa__horaire--complet)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var journeeId = parseInt(btn.getAttribute('data-slot-journee-id'));
        var variantId = parseInt(btn.getAttribute('data-slot-variant-id'));
        var journee = journees.find(function(j) { return j.productId === journeeId; });
        if (!journee) return;

        state.selectedJournee = journee;
        state.selectedVariantId = variantId;
        state.selectedVariantTitle = btn.querySelector('.atelier-resa__horaire-time').textContent.trim();
        state.selectedAtelier = null;

        renderAteliers(journee);
        goToStep(2);

        // If an atelier is preselected via URL, highlight it
        if (preselectedAtelierId && ateliersContainer) {
          var preCard = ateliersContainer.querySelector('[data-atelier-product-id="' + preselectedAtelierId + '"]');
          if (preCard) {
            preCard.classList.add('atelier-resa__atelier--selected');
            preCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });
  }

  function initCalendar() {
    buildDateMap(journees);

    // Update step 1 title if atelier is preselected + récupère son délai minimum
    if (preselectedAtelierId) {
      var atelierName = null;
      journees.forEach(function(j) {
        if (j.ateliers) {
          j.ateliers.forEach(function(a) {
            if (a.productId === preselectedAtelierId) {
              atelierName = a.title;
              if (a.minDelayHours) {
                preselectedMinDelayHours = a.minDelayHours;
              }
            }
          });
        }
      });
      if (atelierName) {
        var stepTitle = document.querySelector('[data-step="1"] .atelier-resa__step-title');
        if (stepTitle) {
          stepTitle.textContent = 'Réserver : ' + atelierName;
        }
      }
    }

    // Find first month with available slots (en respectant le délai minimum si atelier pré-sélectionné)
    var allDates = Object.keys(dateMap).sort();
    var todayKey = getTodayKey();
    var startDate = null;

    for (var i = 0; i < allDates.length; i++) {
      if (allDates[i] < todayKey) continue;
      if (preselectedAtelierId && !meetsMinDelay(allDates[i], preselectedMinDelayHours)) continue;
      startDate = allDates[i];
      break;
    }

    if (startDate) {
      var parts = startDate.split('-');
      state.calendarYear = parseInt(parts[0]);
      state.calendarMonth = parseInt(parts[1]) - 1;
    } else {
      var now = new Date();
      state.calendarYear = now.getFullYear();
      state.calendarMonth = now.getMonth();
    }

    renderCalendar(state.calendarYear, state.calendarMonth);

    // Nav buttons
    if (calendarPrevBtn) {
      calendarPrevBtn.addEventListener('click', function() {
        var m = state.calendarMonth - 1;
        var y = state.calendarYear;
        if (m < 0) { m = 11; y--; }
        renderCalendar(y, m);
        calendarSlotsContainer.style.display = 'none';
        state.selectedDate = null;
      });
    }

    if (calendarNextBtn) {
      calendarNextBtn.addEventListener('click', function() {
        var m = state.calendarMonth + 1;
        var y = state.calendarYear;
        if (m > 11) { m = 0; y++; }
        renderCalendar(y, m);
        calendarSlotsContainer.style.display = 'none';
        state.selectedDate = null;
      });
    }
  }

  // ─── Step 2: Render ateliers ───
  function renderAteliers(journee) {
    if (!ateliersContainer) return;
    ateliersContainer.innerHTML = '';

    if (!journee.ateliers || journee.ateliers.length === 0) {
      ateliersContainer.innerHTML = '<p class="atelier-resa__no-ateliers">Aucun atelier disponible sur ce créneau.</p>';
      return;
    }

    // Trier : atelier présélectionné en premier, puis ordre du metafield
    var sortedAteliers = journee.ateliers.slice();
    if (preselectedAtelierId) {
      sortedAteliers.sort(function(a, b) {
        if (a.productId === preselectedAtelierId) return -1;
        if (b.productId === preselectedAtelierId) return 1;
        return 0;
      });
    }

    sortedAteliers.forEach(function(atelier) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'atelier-resa__atelier';
      card.setAttribute('data-atelier-product-id', atelier.productId);

      var delayOk = meetsMinDelay(state.selectedDate, atelier.minDelayHours);
      var delayMsgHtml = '';
      if (!delayOk) {
        card.classList.add('atelier-resa__atelier--unavailable-delay');
        card.disabled = true;
        var hrs = atelier.minDelayHours || 24;
        delayMsgHtml = '<p class="atelier-resa__atelier-delay-msg">Réservation possible ' + hrs + ' h à l\'avance — choisissez une date ultérieure.</p>';
      }

      var imageHtml = atelier.image
        ? '<div class="atelier-resa__atelier-image"><img src="' + atelier.image + '" alt="' + escapeHtml(atelier.title) + '" loading="lazy"></div>'
        : '';

      card.innerHTML = imageHtml +
        '<div class="atelier-resa__atelier-info">' +
          '<h4 class="atelier-resa__atelier-name">' + escapeHtml(atelier.title) + '</h4>' +
          (atelier.description ? '<p class="atelier-resa__atelier-desc">' + escapeHtml(atelier.description) + '</p>' : '') +
          '<div class="atelier-resa__atelier-meta">' +
            (atelier.duree ? '<span class="atelier-resa__atelier-duree">Durée : ' + escapeHtml(atelier.duree) + '</span>' : '') +
            '<span class="atelier-resa__atelier-prix">' + formatMoney(atelier.prix) + ' / pers.</span>' +
          '</div>' +
          delayMsgHtml +
        '</div>';

      if (delayOk) {
        card.addEventListener('click', function() {
          document.querySelectorAll('.atelier-resa__atelier--selected').forEach(function(el) {
            el.classList.remove('atelier-resa__atelier--selected');
          });
          card.classList.add('atelier-resa__atelier--selected');

          state.selectedAtelier = atelier;
          state.qty = atelier.min || 2;

          updateRecap();
          goToStep(3);
        });
      }

      ateliersContainer.appendChild(card);
    });
  }

  // ─── Step 3: Recap & quantity ───
  function updateRecap() {
    var journee = state.selectedJournee;
    var atelier = state.selectedAtelier;
    if (!journee || !atelier) return;

    var dateLabel = state.selectedDate ? formatDateFrench(state.selectedDate) : journee.title;
    var creneauLabel = dateLabel + ' — ' + state.selectedVariantTitle;
    recapCreneau.textContent = creneauLabel;
    recapAtelier.textContent = atelier.title;
    recapDuree.textContent = atelier.duree || '—';
    recapPrix.textContent = formatMoney(atelier.prix);

    var min = atelier.min || 2;
    var max = atelier.max || 12;
    qtyInput.min = min;
    qtyInput.max = max;
    qtyInput.value = state.qty;
    qtyHint.textContent = min + ' à ' + max + ' personnes';

    updateTotal();
  }

  function updateTotal() {
    if (!state.selectedAtelier) return;
    var total = state.selectedAtelier.prix * state.qty;
    totalPrice.textContent = formatMoney(total);
  }

  // ─── Quantity controls ───
  function initQtyControls() {
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        var min = parseInt(qtyInput.min) || 2;
        if (state.qty > min) {
          state.qty--;
          qtyInput.value = state.qty;
          updateTotal();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        var max = parseInt(qtyInput.max) || 12;
        if (state.qty < max) {
          state.qty++;
          qtyInput.value = state.qty;
          updateTotal();
        }
      });
    }
  }

  // ─── Back buttons ───
  function initBackButtons() {
    var backBtns = document.querySelectorAll('[data-back-step]');
    backBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetStep = parseInt(btn.getAttribute('data-back-step'));
        goToStep(targetStep);
      });
    });
  }

  // ─── Progress steps cliquables (retour arrière) ───
  function initProgressSteps() {
    progressSteps.forEach(function(el) {
      el.addEventListener('click', function() {
        var clickedStep = parseInt(el.getAttribute('data-progress-step'));
        if (clickedStep < state.step) {
          goToStep(clickedStep);
        }
      });
    });
  }

  // ─── Submit reservation ───
  function initSubmit() {
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function() {
      var journee = state.selectedJournee;
      var atelier = state.selectedAtelier;
      if (!journee || !atelier || !state.selectedVariantId) return;

      // Double-check du délai minimum (sécurité si l'UI est contournée)
      if (!meetsMinDelay(state.selectedDate, atelier.minDelayHours)) {
        var hrs = atelier.minDelayHours || 24;
        alert('Cet atelier nécessite une réservation au minimum ' + hrs + ' h à l\'avance. Veuillez choisir une autre date.');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.querySelector('span').textContent = 'Réservation en cours…';

      var dateLabel = state.selectedDate ? formatDateFrench(state.selectedDate) : journee.title;
      var creneauLabel = dateLabel + ' — ' + state.selectedVariantTitle;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: state.selectedVariantId,
              quantity: 1,
              properties: {
                '_type': 'creneau',
                '_atelier_variant_id': String(atelier.variantId)
              }
            },
            {
              id: atelier.variantId,
              quantity: state.qty,
              properties: {
                'Créneau': creneauLabel,
                '_creneau_variant_id': String(state.selectedVariantId)
              }
            }
          ]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || 'Erreur lors de la réservation');
          });
        }
        return response.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(err) {
        alert(err.message || 'Une erreur est survenue. Veuillez réessayer.');
        submitBtn.disabled = false;
        submitBtn.querySelector('span').textContent = 'Réserver';
      });
    });
  }

  // ─── Utils ───
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ─── Init ───
  function init() {
    initCalendar();
    initQtyControls();
    initBackButtons();
    initProgressSteps();
    initSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
